import { jsxs, jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { styled } from "@mui/material";
import { FLAG_EXT } from "./constants.es.js";
import { Alignment } from "../../foundations/alignment.es.js";
import { Displaying } from "../../foundations/displaying.es.js";
function FlagImage({
  children,
  countryCode
}) {
  const imageSrc = `${countryCode.toLowerCase()}.${FLAG_EXT}`;
  return /* @__PURE__ */ jsxs(FlagImageContainer, { children: [
    /* @__PURE__ */ jsx("img", { alt: countryCode, src: imageSrc, width: 22, height: 14 }),
    children
  ] });
}
const FlagImageContainer = styled("div")(({
  theme
}) => ({
  display: Displaying.flex,
  gap: theme.spacing(1),
  alignItems: Alignment.center
}));
export {
  FlagImage
};
//# sourceMappingURL=flag-image.es.js.map
